import gql from 'graphql-tag'

export const GET_LABOURS = gql`
query Labours($filter: GetLaboursFilter) {
    labours(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      labours {
        data {
          code
          companyId
          description
          labourId
          fee
          name
        }
        pagination {
          total
          page
          show
        }
      }
    }
  }
`

export const CREATE_LABOUR = gql`
mutation CreateLabour($input: CreateLabourInput!) {
    createLabour(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createLabour {
        code
        companyId
        description
        fee
        labourId
        name
      }
    }
  }
`

export const GET_LABOUR = gql`
query Labour($filter: GetLabourFilter!) {
    labour(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      labour {
        labourId
        companyId
        code
        name
        description
        fee
      }
    }
  }
`

export const UPDATE_LABOUR = gql`
mutation UpdateLabour($input: UpdateLabourInput!) {
    updateLabour(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateLabour {
        labourId
        companyId
        code
        name
        description
        fee
      }
    }
  }
`
export const DELETE_LABOUR = gql`
mutation DeleteLabour($input: DeleteLabourInput!) {
  deleteLabour(input: $input) {
    isSuccessful
    errorCode
    errorName
    message
    status
    deleteLabour {
      labourId
      companyId
      code
      name
      description
      fee
    }
  }
}
`